import React, { ReactElement } from 'react';

import { TTextAreaProperties } from './text-area.types';
import { StyledTextArea } from './text-area.styled';

export function TextArea({
    hasError = false,
    ...otherProperties
}: TTextAreaProperties): ReactElement {
    return <StyledTextArea aria-invalid={hasError} {...otherProperties} />;
}
